// Utility function to normalize markdown text for proper rendering of
// tables and headers. Mirrors the backend normalize() logic.

export function normalizeMarkdown(value) {
  let s = (value || "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .trim();

  // Separate headings that stick to previous text
  s = s.replace(/(\S)\s*(?=(#{1,6}\s))/g, "$1\n\n");

  // Split heading and first table row if they are in one paragraph
  s = s.replace(/^((#{1,6}\s[^\n]*?)\s*)(\|.+)$/gm, "$2\n\n$3");

  // Split last table row and following heading if they are in one paragraph
  s = s.replace(/(\|.+\|)\s+(#{1,6}\s)/g, "$1\n\n$2");

  const lines = s.split("\n");
  const out = [];

  function isTableLine(raw) {
    const t = raw.trim();
    if (t === "") return false;
    if (t.startsWith("|")) return true;
    if (/^[| ]?-{3,}([| ]+-{3,})+[| ]*$/.test(t)) return true;
    if (!t.includes("|")) return false;
    const cells = t.split("|").filter((segment) => segment.trim().length > 0);
    return cells.length >= 2;
  }

  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (isTableLine(line)) {
      if (out.length > 0 && out[out.length - 1].trim() !== "") out.push("");

      let j = i;
      while (j < lines.length && (isTableLine(lines[j]) || lines[j].trim() === "")) {
        if (isTableLine(lines[j])) out.push(lines[j].replace(/\s+$/g, ""));
        j++;
      }

      if (j < lines.length && out.length > 0 && out[out.length - 1].trim() !== "") out.push("");
      i = j;
    } else {
      out.push(line);
      i++;
    }
  }

  return out
    .join("\n")
    .replace(/^(#{1,6} .*)\n(\S)/gm, "$1\n\n$2")
    .replace(/\n+$/g, "");
}
